import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import LoadingComponent from "../../../../common/LoadingComponent";

import {
  Button,
  Header,
  Modal,
  Message,
  Grid,
} from "semantic-ui-react";

class ShowPlaybookMetaData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      updatedMetaDataSchema: this.props.metaDataSchema,
      loader: false
    };
  }

  componentWillMount() {}

  close = () => {
    this.props.setMetaDataFlag(false);
  };
  IsValidJSONString = (e, data) => {
    try {
      JSON.parse(e.target.value);
    } catch (e) {
      this.setState({ isJSONValid: false });
      return false;
    }
    this.setState({
      isJSONValid: true,
      updatedMetaDataSchema: JSON.parse(e.target.value),
    });
    return true;
  };
  onSubmitNewTemplate = (data) => {};

  async saveUpdatedMetaData() {
    // Below changes for KLM-9001
    this.setState({loader: true})
    if(this.props.view==="configure"||this.props.view==="sequence"){
      let payload = {
        ...this.props.selectedPracticeFlowActivity
      }
      payload[this.props.shemaUpdationKey]=this.state.updatedMetaDataSchema;
      dispatch.lifeCycle.updatePlaybookActivities(payload).then(() => {
        this.props.setMetaDataFlag(false);
        this.setState({loader: false})
      })
    }else if(this.props.view==="playbook"){
      let key = this.props.shemaUpdationKey
      this.props.selectedPracticeLibrary[key] = this.state.updatedMetaDataSchema
      await dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
        this.props.setMetaDataFlag(false);
        this.setState({loader: false});
    }
  }
  render() {
    const errorLabel = <div className="customErrorLabel" />;
    const { metaDataSchema } = this.props;
    return (
      <div>
      <LoadingComponent active={this.state.loader} message="Saving Metadata Schema... " />
      <Modal
        open={this.props.open}
        onClose={this.close}
        size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header
          content={`Manage Metadata `}
        />
        <Modal.Content>
          <Form
            noValidate
            ref={(ref) => (this.form = ref)}
            className="formcyForm"
            name="cretePack"
            id="cretePackID"
            onValidSubmit={(event) => {
              this.onSubmitNewTemplate(event);
            }}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Form.TextArea
                    required
                    name="rule"
                    label="Metadata"
                    id="Condition"
                    onChange={(e, data) => this.IsValidJSONString(e, data)}
                    value={JSON.stringify(metaDataSchema, null, 4)}
                    errorLabel={errorLabel}
                    style={{ minHeight: "300px" }}
                    instantValidation
                  />
                  {!this.state.isJSONValid ? (
                    <Message
                      className="bg-warning"
                      style={{
                        float: "left",
                        padding: "8px",
                        width: "calc(100% - 200px)",
                        textAlign: "center",
                      }}
                      content="Please enter valid JSON"
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="button-cancel"
            id="cancelSchema"
            onClick={this.close}
          >
            Close
          </Button>
          <Button
            className="button-submit"
            id="cancelSchema"
            onClick={() => this.saveUpdatedMetaData(metaDataSchema)}
            disabled={!this.state.isJSONValid ? true : false}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }
}

export default ShowPlaybookMetaData;
